import { render, staticRenderFns } from "./DeliveryDetailsBlock.vue?vue&type=template&id=4e05b5fb&lang=pug&"
import script from "./DeliveryDetailsBlock.vue?vue&type=script&lang=js&"
export * from "./DeliveryDetailsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports